import { lazy, Suspense } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import { AnimatePresence, MotionConfig } from 'framer-motion'
import Layout from './components/shared/layout/Layout'
import { ThemeProvider } from './contexts/ThemeContext'
import { ScrollToTop } from './components/shared/ScrollToTop'
import { CookieConsent } from './components/shared/CookieConsent'
import { Seo } from './components/shared/Seo'
import HomePage from './pages/HomePage'

// The landing page ships in the main bundle; the rarely visited pages are
// lazy-loaded so they stay out of it.
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'))
const TermsPage = lazy(() => import('./pages/TermsPage'))
const NotFound = lazy(() => import('./pages/NotFound'))

function App() {
  const location = useLocation()

  return (
    <ThemeProvider>
      <MotionConfig
        reducedMotion="user"
        transition={{
          type: 'tween',
          duration: 0.5,
          ease: [0, 0, 0.2, 1]
        }}
      >
        <ScrollToTop />
        <Seo />
        <AnimatePresence mode="wait">
          <Layout>
            <Suspense fallback={<div className="min-h-screen" />}>
              <Routes location={location} key={location.pathname}>
                <Route path="/" element={<HomePage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </Layout>
        </AnimatePresence>
        <CookieConsent />
      </MotionConfig>
    </ThemeProvider>
  )
}

export default App
